import React from 'react'

import ContentInner from './contentInner'
import TitleInner from './titleInner'

import styles from './contentInnerWrapper.module.scss'

const ContentInnerWrapper = props => {
  const { title, className } = props

  return (
    <div className={styles.contentInnerWrapper}>
      <ContentInner>
        {
          !!title
            ? <TitleInner title={title} className={!!className ? className : ''} />
            : null
        }
        {props.children}
      </ContentInner>
    </div>
  )
}

export default ContentInnerWrapper;
